import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { getExtensionFromUrl, getMediaType } from '@shared/util/media/type';
import { MBChatAttachmentFallback, MBChatAttachmentFallbackSquare } from './fallback';
import { MBChatImageAttachmentWithPreview } from './image/withPreview';
import { Styles } from './styles';
import { MBChatVideoAttachmentWithPreview } from './video/withPreview';

export interface MBChatAttachmentProps {
  attachment: MBAPI.ChatAttachment;
  isSending?: boolean;
  fallback?: 'square' | 'normal';
  progress?: number;
  style?: StyleProp<ViewStyle>;
  forcedHeight?: number;
  backgroundColor?: string;
  onLongPress?: () => void;
  onClick?: (attachment: MBAPI.ChatAttachment) => void;
  containerWidth?: number;
  containerHeight?: number;
}

/*
    Attachment item shown in a chat thread. Shows different content depending
    on the attachment's file extension. Currently we support the following
    file types:
      * images (webp, jpg, png, gif)
      * video (mp4) - Note: not yet on ios

    If the attachment file type isn't supported, we show a default fallback
    attachment list row.
*/
export function MBChatAttachmentComponent(props: MBChatAttachmentProps) {
  const extension = getExtensionFromUrl(props.attachment.name);
  const mediaType = getMediaType(extension, props.attachment.contentType);

  if (mediaType === 'image') {
    return (
      <MBChatImageAttachmentWithPreview
        {...props}
        style={[Styles.container, Styles.border, props.style]}
      />
    );
  }

  if (mediaType === 'video') {
    return (
      <MBChatVideoAttachmentWithPreview
        {...props}
        style={[Styles.container, Styles.border, props.style]}
      />
    );
  }

  if (props.fallback === 'square') {
    return <MBChatAttachmentFallbackSquare {...props} style={[Styles.container, props.style]} />;
  }

  return <MBChatAttachmentFallback {...props} style={[Styles.container, props.style]} />;
}
